import "./remerciement.css";
import {useContext, useEffect} from "react";
import {ObjectContext} from "../../context/ObjectContext";

const RemerciementSignature = () => {

  const setFooterColor = useContext(ObjectContext).setFooterColor;

  useEffect(() => {
    setFooterColor("#010064");
  }, []);

  return (
    <div className="remerciement" style={{color:"#d2fa94"}}>
      <h1>Merci pour votre inscription !</h1>
      <p>Consultez votre boite courriel où se trouve en pièce jointe votre guide utilisateur.</p>
      <button onClick={() => window.location.href = "/"}>Retour à la page d'accueil</button>
    </div>
  )
};

export default RemerciementSignature;